import { useEffect, useState, useCallback, useRef } from "react";
import BilderUebersicht from "./TabContent-Details/BilderUebersicht";
import Kinder from "./TabContent-Details/Kinder";
import {
  useTourGuidConfigContext,
  useTourGuidStartActionsContext,
  useTourGuidConfigActionsContext,
  useTourGuidSavedSettingContext,
  useTourGuidSavedSettingActionsContext,
  useTourGuidStartContext,
} from "../../Context/TourGuidContext";
import { TourGuideHelper } from "../../helpers/TourGuide/TourGuideHelper";
import Responsibilities from "./TabContent-Details/Responsibilities";
import EquipmentDetailOverview from "../Equipment-Details/EquipmentDetailOverview";
import DocumentListView from "../Equipment-Details/DocumentListView";
import InspectionList from "../Equipment-Details/InspectionList";
import Tickets from "./TabContent-Details/Tickets";
import { EquipGrpPublicInfoProvider } from "../../Context/EquipGroupPublicInfoContext";
import Maintenance from "./TabContent-Details/Maintenance";
function TabContent({
  tabid,
  anlageid,
  handleTabSelection,
  isFunctionCall,
  tabs,
}) {
  const startTour = useTourGuidStartContext();
  const UpdateTourStatus = useTourGuidStartActionsContext();
  const tourGuidSaveSetting = useTourGuidSavedSettingContext();
  const setTourGuidSaveSetting = useTourGuidSavedSettingActionsContext();
  const guideTourstate = useTourGuidConfigContext();
  const setGuideTourState = useTourGuidConfigActionsContext();
  const isMountedRef = useRef(null);
  const [renderElement, setRenderElement] = useState(null);
  const ifFirstMount = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => (isMountedRef.current = false);
  }, []);

  const returnPosition = (_value) => {};
  const handleTourGuid = useCallback(
    (_value) => {
      if (!guideTourstate.tourActive && startTour.tourStatus) {
        setGuideTourState((prev) => ({
          ...prev,
          run: true,
          stepIndex: tabs.findIndex((item) => _value === item.id),
        }));
      }
      if (ifFirstMount.current) {
        ifFirstMount.current = false;
        const _tempTourConfig = TourGuideHelper.returnCurrentTourState(
          tourGuidSaveSetting,
          setTourGuidSaveSetting,
          "EquipmentDetailsViewTour",
        );
        if (_tempTourConfig.length > 0) {
          UpdateTourStatus({
            tourTitle: _tempTourConfig[0].title,
            tourStatus: true,
            anyStep: 0,
            lastIndexKey: tabs[tabs.length - 1].id,
            firstIndexKey: tabs[0].id,
          });
        }
      }
    },
    [tourGuidSaveSetting, startTour],
  );
  useEffect(() => {
    if (isMountedRef.current) {
      var _tabid = Number(sessionStorage.getItem("tabid")) || tabid;

      switch (_tabid) {
        case 1:
          setRenderElement(
            // <Allgemein
            //   tabid={_tabid}
            //   anlageid={anlageid}
            //   handleTourGuid={handleTourGuid}
            // />
            <EquipmentDetailOverview
              tabid={_tabid}
              anlageid={anlageid}
              handleTourGuid={handleTourGuid}
              handleTabSelection={handleTabSelection}
            />,
          );
          break;
        case 2:
          setRenderElement(
            // <Auftraege
            //   tabid={_tabid}
            //   anlageid={anlageid}
            //   handleTourGuid={handleTourGuid}
            // />
            <InspectionList
              anlageid={anlageid}
              handleTourGuid={handleTourGuid}
            />,
          );
          break;
        case 3:
          setRenderElement(
            <BilderUebersicht
              anlageid={anlageid}
              handleTourGuid={handleTourGuid}
            />,
          );
          break;
        case 4:
          setRenderElement(
            // <Dokumentablage
            //   tabid={_tabid}
            //   anlageid={anlageid}
            //   handleTourGuid={handleTourGuid}
            // />
            <DocumentListView
              tabid={_tabid}
              anlageid={anlageid}
              handleTourGuid={handleTourGuid}
            />,
          );
          break;
        case 5:
          setRenderElement(
            // <ReparaturUebersicht
            //   anlageid={anlageid}
            //   handleTourGuid={handleTourGuid}
            // />
            <Maintenance anlageid={anlageid} handleTourGuid={handleTourGuid} />,
          );
          break;
        case 6:
          setRenderElement(
            <Kinder
              anlageid={anlageid}
              handleTabSelection={handleTabSelection}
              isFunctionCall={isFunctionCall}
              handleTourGuid={handleTourGuid}
            />,
          );
          break;
        case 7:
          setRenderElement(
            <Responsibilities
              anlageid={anlageid}
              handleTabSelection={handleTabSelection}
              isFunctionCall={isFunctionCall}
              handleTourGuid={handleTourGuid}
            />,
          );
          break;
        case 8:
          setRenderElement(
            <Tickets
              anlageid={anlageid}
              handleTabSelection={handleTabSelection}
              isFunctionCall={isFunctionCall}
              handleTourGuid={handleTourGuid}
            />,
          );
          break;
        default:
          setRenderElement(null);
          break;
      }
    }

    return () => {
      setRenderElement(null);
    };
  }, [tabid, anlageid]);

  return (
    <div className="tab-content">
      <EquipGrpPublicInfoProvider>{renderElement}</EquipGrpPublicInfoProvider>
    </div>
  );
}
export default TabContent;
